import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.readonly)?[_vm._v(" "+_vm._s(_vm.text)+" ")]:_c(VTextField,_vm._b({model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}},'v-text-field',_vm.$attrs,false))],2)}
var staticRenderFns = []

export { render, staticRenderFns }